<template>
    <!-- Modal -->
    <div class="modal fade" id="emailMigrateModal" tabindex="-1" role="dialog" aria-labelledby="emailMigrateModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Migrate Email Account.</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="text-danger">
                        <span class="badge badge-danger mb-0">Please Note</span>
                        Your old and new email password may be the same password.
                    </p>
                    <div class="form-group mb-4">
                        <label for="migrateEmail">Email</label>
                        <input disabled :value="email" type="text" class="form-control" id="migrateEmail" />
                    </div>
                    <div class="form-group mb-4">
                        <label for="oldHost">Old Mail Server Hostname</label>
                        <input v-model="oldHost" type="text" class="form-control" id="oldHost" placeholder="Ex. imap.google.com" />
                    </div>
                    <div class="form-group mb-4">
                        <label for="oldEmailPassword">Old Email Password</label>
                        <input v-model="oldPassword" type="text" class="form-control" id="oldEmailPassword" placeholder="Please enter your password." />
                    </div>
                    <div class="form-group">
                        <label for="newEmailPassword">New Email Password</label>
                        <input v-model="newPassword" type="text" class="form-control" id="newEmailPassword" placeholder="Please enter your password." />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" :disabled="migrateLoading" class="btn btn-primary" @click="startMigration">
                        <div class="loader mini_loader" v-if="migrateLoading"></div>
                        <span v-else>Start Migration</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import swal from 'sweetalert2';
    export default {
        name: "Migrate",
        data () {
          return {
              migrateLoading: false,
              email: '',
              oldPassword: '',
              newPassword: '',
              oldHost: ''
          }
        },
        computed: {
            userUID() {
                return this.$store.getters.getUID;
            }
        },
        methods: {
            load (email) {
                this.email = email;
                $("#emailMigrateModal").modal('show');
            },
            startMigration () {
                this.migrateLoading = true;
                this.$http.post('email/migrate', {
                    grant_type: 'token',
                    email: this.email,
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword,
                    oldHost: this.oldHost,
                    UID: this.userUID
                }).then(resp => {
                    console.log(resp.data);
                    $("#emailMigrateModal").modal('hide');
                    swal('Request Received!', resp.data.msg, 'success');
                }).catch(e => {
                    console.log(e);
                    if(e.response.status === 422) {
                        let errors = '<ul>';
                        e.response.data.errors.map(error => {
                            errors += '<li>' + error.msg + '</li>';
                        });
                        errors += '</ul>';
                        swal('Error!', errors, 'error');
                    } else {
                        swal('Error', 'There is something wrong! Please try again later', 'error');
                    }

                }).finally(() => {
                    this.migrateLoading = false;
                    this.oldHost = '';
                    this.oldPassword = '';
                    this.newPassword = '';
                })
            }
        }
    }
</script>

<style scoped>

</style>
